import React from "react";
import { AxiosError, AxiosResponse } from "axios";
import { createMonitoringAPICall } from "./createMonitoringAPICall";
import { fetchGroupTrees } from "./fetchGroupTrees";
import { logger } from "../../utils/logger";

export const getRefreshTimeout = (id: number) => {
  const AxiosUI = createMonitoringAPICall(``);

  AxiosUI.get(`group/${id}`).then(
    (response: AxiosResponse) => {
      localStorage.setItem(
        "refresh_interval",
        JSON.stringify(response.data.refresh_interval_seconds * 1000)
      );
      return response.data.refresh_interval_seconds * 1000;
    },
    (reason: AxiosError) => {
      logger.log("error reason:", reason);
      localStorage.setItem("refresh_interval", "1000");
      return 1000;
    }
  );
};
